export default __webpack_public_path__ + "static/media/23-min.b5b42c78.jpg";